import React from 'react';
import { Grid } from '@mui/material';
import { CustomTypography } from '../shared/custom-typography/CustomTypography';
import { CustomGridItem } from './custom-grid-item/CustomGridItem';
import { CustomGridRow } from './custom-grid-row/CustomGridRow';
import { useLocalStore } from '../local-store-provider/LocalStoreProvider.utils';
import { RevenueCalculatorStore } from '../revenue-calculator/RevenueCalculator.store';
import { observer } from 'mobx-react';
import { toCurrency } from '../../utils/currency/currency.utils';
import { CurrencyCode } from '../../utils/currency/currency.constants';
import { displayStringNumber } from '../../utils/utils';
import { TableHeader } from './table-header/TableHeader';

export const CalculatorTotals: React.FC = observer(() => {
  const localStore = useLocalStore<RevenueCalculatorStore>();

  return (
    <Grid
      container={true}
      item={true}
      marginY={3}
    >
      <CustomGridRow isHeader={true}>
        <Grid
          item={true}
          xs={3}
          flexGrow={1}
        >
          <CustomTypography
            align={'left'}
            fontWeight={'bold'}
            fontSize={'1rem'}
          >
            Roles
          </CustomTypography>
        </Grid>
        <TableHeader title={'Billable Utilization'} />
        <TableHeader title={'Head Count'} />
        <TableHeader title={'Available Hours'} />
        <TableHeader title={'Billable Hours'} />
        <TableHeader title={'Avg. Hourly Bill Rate'} />
      </CustomGridRow>

      <CustomGridRow borderBottom={'1px solid lightgray'}>
        <CustomGridItem
          text={'Billable Employees'}
          xs={3}
          align={'left'}
          flexGrow={1}
        />
        <CustomGridItem text={`${localStore.billableEmployeeUtilizationTarget}%`} />
        <CustomGridItem text={`${localStore.billableEmployeeCount}`} />
        <CustomGridItem text={displayStringNumber(localStore.availableBillableHours)} />
        <CustomGridItem text={displayStringNumber(localStore.billableHours)} />
        <CustomGridItem
          text={toCurrency(localStore.averageHourlyBillRate, { currencyCode: CurrencyCode.USD, fractionDigits: 2 })}
        />
      </CustomGridRow>

      <CustomGridRow>
        <CustomGridItem
          align={'left'}
          flexGrow={1}
          text={'Non Billable Employees'}
          xs={3}
        />
        <CustomGridItem text={'0%'} />
        <CustomGridItem text={`${localStore.nonBillEmployeeCount}`} />
        <CustomGridItem text={displayStringNumber(localStore.availableNonBillHours)} />
        <CustomGridItem text={'0'} />
        <CustomGridItem text={'$0.00'} />
      </CustomGridRow>
    </Grid>
  );
});

CalculatorTotals.displayName = 'CalculatorTotals';
